export enum AgrupacionRemitos {
    DireccionEntrega = 0,
    Aeroplanta = 1,
    Provincia = 2,
    Remito = 3
}